<mat-dialog-content>
  <label style="font-size: medium; font-weight: bold;">Seleccione la persona a firmar</label>
  <mat-radio-group class="example-radio-group" [(ngModel)]="firmaDefault">
    @for (firma of firmas; track firma) {
    <mat-radio-button class="example-radio-button" [value]="firma">{{firma.nombres}}
      ({{firma.ciruc}})</mat-radio-button>
    }
  </mat-radio-group>
  <mat-form-field class="full-width">
    <mat-label>Clave firma electr&oacute;nica</mat-label>
    <mat-icon matPrefix>key</mat-icon>
    <input #clave [formControl]="txtClave" matInput [type]="hide ? 'password' : 'text'" autoFocus>
    <button type="button" mat-icon-button matSuffix (click)="clickEvent($event)"
      [attr.aria-label]="'Ocultar contrase&ntilde;a'" [attr.aria-pressed]="hide">
      <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
    </button>
    <mat-error>Ingrese la contrase&ntilde;a</mat-error>
  </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions>
  <button type="button" mat-button mat-dialog-close>Cancelar</button>
  <button type="submit" mat-flat-button (click)="onAceptar()" [disabled]="!txtClave.valid || fetchingSignDocument">
    <div class="btn-login-content">
      @if (fetchingSignDocument) {
      <mat-spinner diameter="20" color="warn"></mat-spinner>
      }@else{
      <p>Aceptar</p>
      }
    </div>
  </button>
</mat-dialog-actions>